import type { TLocalAuthContext } from '../types';

export function isLocalAuthContext(context?: TLocalAuthContext): context is TLocalAuthContext {
  return context !== undefined;
}

export function createUserDataFromExternalUserInteractionId(id: string) {
  return {
    id: `external-${id}`,
    name: `external-${id}`,
    email: `external.${id}@mindtickle.com`,
  };
}
